import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";

/* COMPONENTS */
import TripResults from "./components/TripResults";
import ProfilePage from "./components/ProfilePage";
import ItineraryPage from "./components/ItineraryPage";
import ItineraryDetail from "./components/ItineraryDetail";
import SavedItineraries from "./components/SavedItineraries";
import PackingList from "./components/PackingList";
import ExploreCities from "./components/ExploreCities";
import CityPage from "./components/CityPage";
import BecomeGuide from "./components/BecomeGuide";
import AiFailPage from "./components/AiFaliPage";
import Blogs from "./components/Blogs";
import BlogDetail from "./components/BlogDetail";
import AdminBlog from "./components/AdminBlog";
import BlogEdit from "./components/BlogEdit";
import DistanceCalculator from "./components/DistanceCalculator";
import PublicTrip from "./components/PublicTrip";
import QuizPage from "./pages/QuizPage";
import TokenHistoryPage from "./components/TokenHistoryPage";
import HelpPage from "./pages/HelpPage";
import AuthSuccess from "./pages/AuthSuccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PlanPage from "./pages/TripPlanner";
//import OwnerTripPage from "./components/OwnerTripPage";
// import TripOverviewPage from "./pages/TripOverviewPage";
// import TicketsPage from "./pages/TicketPage";
// import StaysPage from "./pages/StaysPage";
// import ExpensesPage from "./pages/ExpensesPage";
// import DocumentsPage from "./pages/DocumentsPage";
import TripHubPage from "./pages/TripHubPage";
import TripInvitePage from "./pages/TripInvitePage";
import JoinTripPage from "./pages/JoinTripPage";
import TripHelp from "./pages/TripHelp";
/* ADMIN */
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import PublicTripPage from "./pages/PublicTripPage";
import Apply from "./pages/curator/Apply";
import Dashboard from "./pages/curator/Dashboard";
import CreateTrip from "./pages/curator/CreateTrip";
import Explore from "./pages/curator/Explore";
import Creators from "./pages/curator/Creators";
import CreatorProfile from "./pages/curator/CreatorProfile";
import CuratedTripDetail from "./pages/curator/CuratedTripDetail";
import BecomeCreator from "./pages/curator/BecomeCreator";
import VaultHub from "./pages/VaultHub";
import TripSharePage from "./pages/TripSharePage";
const AppRouter = ({
  currentUser,
  setCurrentUser,
  handleLogout,
  navigate,
  homeContent,
  openLogin,

  formCardRef,
  handleSubmit,
  tripType,
  setTripType,
  hours,
  setHours,
  days,
  setDays,
  multiStartDate,
  setMultiStartDate,
  place,
  setPlace,
  group,
  setGroup,
  suggestions,
  setSuggestions,
  addSuggestion,
  loading,
  apiStatus,
  citySuggestions,
  showSuggestions,
  setShowSuggestions,
  tripDate,
  setTripDate,
}) => {
  return (
    <Routes>
      {/* ===== MAIN LAYOUT WRAPPER ===== */}
      <Route
        element={
          <MainLayout
  user={currentUser}
  onLogoutClick={handleLogout}
  onSignInClick={openLogin}
/>
        }
      >
        <Route path="/" element={homeContent} />
 <Route path="/auth-success" element={<AuthSuccess />} />
        <Route
          path="/results"
          element={<TripResults openLogin={openLogin} />}
        />

       
  <Route
  path="/plan"
  element={
    <div className="min-h-screen bg-[#f7f6f1] pt-28">

      <div className="max-w-5xl mx-auto px-6">

        {/* PLANNER AT TOP */}
        <PlanPage
          formCardRef={formCardRef}
          handleSubmit={handleSubmit}
          tripType={tripType}
          setTripType={setTripType}
          hours={hours}
          setHours={setHours}
          days={days}
          setDays={setDays}
          multiStartDate={multiStartDate}
          setMultiStartDate={setMultiStartDate}
          place={place}
          setPlace={setPlace}
          group={group}
          setGroup={setGroup}
          suggestions={suggestions}
          setSuggestions={setSuggestions}
          addSuggestion={addSuggestion}
          loading={loading}
          citySuggestions={citySuggestions}
          showSuggestions={showSuggestions}
          setShowSuggestions={setShowSuggestions}
          tripDate={tripDate}
          setTripDate={setTripDate}
        />

      </div>

    </div>
  }
/>

        {/* ITINERARIES */}
        <Route path="/itineraries" element={<ItineraryPage />} />
        <Route path="/itineraries/:slug" element={<ItineraryDetail />} />

        {/* CITIES */}
        <Route path="/cities" element={<ExploreCities />} />
        <Route path="/cities/:slug" element={<CityPage />} />
        
        {/* PROGRAMMATIC SEO ROUTES (Prepared for future expansion) */}
        <Route path="/things-to-do-in-:slug" element={<CityPage />} />
        <Route path="/:slug-itinerary-:duration-days" element={<ItineraryDetail />} />
        <Route path="/best-time-to-visit-:slug" element={<CityPage />} />

        {/* USER */}
        <Route
          path="/profile"
          element={
            <ProfilePage
              user={currentUser}
              setCurrentUser={setCurrentUser}
              onLogout={handleLogout}
            />
          }
        />
        <Route
  path="/trip/:travelKeyToken"
  element={<TripHubPage />}


/>
<Route path="/trip-help" element={<TripHelp />} />

<Route
  path="/trip/:travelKeyToken/invite"
  element={<TripInvitePage />}
/>

<Route
  path="/trip/:travelKeyToken/share"
  element={<TripSharePage />}
/>
<Route path="/curator/apply" element={<Apply />} />
        <Route path="/saved" element={<SavedItineraries />} />
        <Route path="/packing" element={<PackingList />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/tokens" element={<TokenHistoryPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/share/:shareToken" element={<PublicTripPage />} />
        <Route path="/join/:token" element={<JoinTripPage />} />
        {/* OTHERS */}
        <Route path="/blogs" element={<Blogs currentUser={currentUser} />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/blogs/admin" element={<AdminBlog currentUser={currentUser} />} />
        <Route path="/blogs/admin/edit/:id" element={<BlogEdit />} />
        <Route path="/distance" element={<DistanceCalculator />} />
        <Route path="/become-guide" element={<BecomeGuide />} />
        <Route path="/ai-failed" element={<AiFailPage />} />
        <Route path="/share/:token" element={<PublicTrip />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
          <Route path="/curator/dashboard" element={<Dashboard />} />
<Route path="/curator/create" element={<CreateTrip />} />
<Route path="/explore" element={<Explore />} />
<Route path="/creators" element={<Creators />} />
<Route path="/creator/:id" element={<CreatorProfile />} />
<Route path= "/curated/:id" element={<CuratedTripDetail/>}/>
<Route path="/trip/:travelKeyToken/vault" element={<VaultHub />} />
<Route path="/become-creator" element={<BecomeCreator />} />
        {/* ADMIN */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
        </Route>

        <Route path="*" element={homeContent} />
      </Route>
    </Routes>
  );
};

export default AppRouter;